import React from 'react'
import { createStyles, withStyles } from '@mui/styles'
import { muiOptions, MuiProps } from '../../../infrastructure/materialUiThemeProvider'
import { TextField } from './textfield'
import { hasFeature } from '../../../infrastructure/feature'
import { t } from 'i18next'

type FactorFieldProps = {
    tradKey: string
    productUnit: string | undefined
    value: number | null
    inputProps?: any
    disableNewStyle?: boolean
}

function _ToBBLFactorField({ classes, value, tradKey, productUnit, ...props }: FactorFieldProps & MuiProps) {
    return (
        <_FactorField text={value ? parseFloat(value.toFixed(5)) : null} label={t(tradKey, { unit: productUnit })} {...props} />
    )
}

function _ToVolumeFactorField({ classes, value, tradKey, productUnit, ...props }: FactorFieldProps & MuiProps) {
    value = value === 0 ? 0
        : !value ? null
            : hasFeature('reverseConversionFactor') ? parseFloat((1 / value).toFixed(5))
                : parseFloat(value.toFixed(5))
    let unit = hasFeature('reverseConversionFactor') ? `${productUnit ?? ''}/TO` : `TO/${productUnit ?? ''}`
    return (
        <_FactorField text={value ? parseFloat(value.toFixed(5)) : null} label={t(tradKey, { unit: unit, interpolation: { escapeValue: false } })} {...props} />
    )
}

type InternalFactorFieldProps = {
    label: string
    text: number | null
    inputProps?: any
    disableNewStyle?: boolean
}

function _FactorField({ text, label, inputProps, ...props }: InternalFactorFieldProps) {
    return (
        <TextField {...props} label={label} text={text} inputProps={inputProps} disabled />
    )
}

let styles = theme => createStyles({})

export let ToBBLFactorField = withStyles(styles, muiOptions)(_ToBBLFactorField)
export let ToVolumeFactorField = withStyles(styles, muiOptions)(_ToVolumeFactorField)